// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"styles":"812267bb0337993837de","default":"179f264a779f1cc3b59d","dark":"d73fe9fb9156c4d42c28"}[chunkId] + ".css";
};